import { useEffect } from 'react';

import { useNavigation } from '@/context/NavigationContext';

interface PathRedirectPageProps {
  target: string;
}

export default function PathRedirectPage({ target }: PathRedirectPageProps) {
  const navigation = useNavigation();

  useEffect(() => {
    navigation.navigate(target, { replace: true });
  }, [navigation, target]);

  return null;
}
